export class RecommendedController {
  constructor($rootScope, $scope, UserService, LikeService, socket, toastr, $interval) {
    this.scope = $scope;
    this.interval = $interval;
    this.rootScope = $rootScope;
    this.toastr = toastr;
    this.LikeService = LikeService;
    this.UserService = UserService;
    this.socket = socket;

    this.init();
  }

  init() {
    this.scope.isLoadedPage = false;
    this.scope.show = {success: false, error: false};
    this.scope.timer = { id: null, hours: '00', mins: '00', secs: '00' };
    this.scope.users = [];

    this.scope.getUsers = () => {
      this.UserService.getUsers(this.rootScope.currentUserProfile.recommendations.users)
      .then((response) => { let users = response.data;
        this.scope.users = users.data;
        this.scope.isLoadedPage = true;
      })
      .catch((response) => { let err = response.data;
        console.error(err);
      })
    }

    this.scope.createRecommendation = () => {
      let request = {user: this.rootScope.currentUserProfile._id};
      this.UserService.createRecommendation(request)
        .then((_res) => { let response = _res.data;
          if(response.success) {
            this.rootScope.currentUserProfile.recommendations = response.recommendations;
            this.socket.emit('counters');
            this.scope.getUsers();
          }
        })
        .catch((response) => { let err = response.data;
          console.error(err)
        });
    }

    this.scope.setLike = (userId) => {
      if (this.rootScope.currentUserProfile.status == 0) {
        this.toastr.warning('Your profile is deactivated, you can\'t do this.');
        return;
      }

      let params = {giver: this.rootScope.currentUserProfile._id, receiver: userId};
      this.socket.emit('like_set', JSON.stringify(params));
      _.remove(this.rootScope.currentUserProfile.recommendations.users, (user) => user === userId);
      this.UserService.updateRecommendations(this.rootScope.currentUserProfile._id, this.rootScope.currentUserProfile.recommendations)
        .then((response) => { let data = response.data;
          this.rootScope.currentUserProfile.recommendations = data.recommendations;
          this.socket.emit('counters');
          if(data.recommendations && data.recommendations.countdown && moment(data.recommendations.countdown).diff(moment()) > 0) {
            this.setRecInterval();
          }
          this.scope.getUsers();
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        })
    }

    this.scope.removeUser = (userId) => {
      if (this.rootScope.currentUserProfile.status == 0) {
        this.toastr.warning('Your profile is deactivated, you can\'t do this.');
        return;
      }

      async.parallel([
        (callback) => {
          this.UserService.addToIgnore(userId)
            .then((response) => {
              callback();
            })
            .catch((response) => { let err = response.data;
              callback(err);
            })
        },

        (callback) => {
          _.remove(this.rootScope.currentUserProfile.recommendations.users, (user) => user === userId);
          this.UserService.updateRecommendations(this.rootScope.currentUserProfile._id, this.rootScope.currentUserProfile.recommendations)
            .then((response) => { let data = response.data;
              this.rootScope.currentUserProfile.recommendations = data.recommendations;
              this.socket.emit('counters');
              if(data.recommendations && data.recommendations.countdown && moment(data.recommendations.countdown).diff(moment()) > 0) {
                this.setRecInterval();
              }
              callback();
            })
            .catch((response) => { let err = response.data;
              callback(err);
            })
        }
      ], (err) => {
        if(err) {
          console.error(err);
        }

        this.scope.getUsers();
      })
    }

    this.UserService.getCurrentUser()
      .then((response) => { let user = response.data;
        this.rootScope.currentUserProfile = user.data;
        let recommendations = this.rootScope.currentUserProfile.recommendations;
        if(!recommendations
          || (!recommendations.countdown && !recommendations.users.length)
          || (recommendations.countdown && moment(recommendations.countdown).diff(moment()) <= 0)) {
          this.scope.createRecommendation();
        } else if (recommendations && recommendations.countdown && moment(recommendations.countdown).diff(moment()) > 0) {
          this.setRecInterval();
          this.scope.isLoadedPage = true;
        } else {
          this.scope.getUsers();
        }
      })
      .catch((response) => { let err = response.data;
        console.error(err);
      })
  }

  setRecInterval() {
    let callback = () => {
      let countdown = this.rootScope.currentUserProfile.recommendations.countdown;
      let timeDiff = moment(countdown).diff(moment());
      if(timeDiff < 0) {
        this.interval.cancel(this.scope.timer.id);
        this.rootScope.currentUserProfile.recommendations.countdown = null;
        this.scope.createRecommendation();
      } else {
        let dateDiff = new Date(timeDiff);
        this.scope.timer.hours = dateDiff.getUTCHours();
        this.scope.timer.mins = dateDiff.getUTCMinutes();
        this.scope.timer.secs = dateDiff.getUTCSeconds();
      }
    };
    callback();

    this.interval.cancel(this.scope.timer.id);
    this.scope.timer.id = this.interval(callback, 1000);
  }

}
